/* eslint-disable no-console */

import { register } from "register-service-worker";

let refreshing = false;

register(`${process.env.BASE_URL}service-worker.js`, {
  ready() {
    console.log("App is being served from cache.");
  },

  registered() {
    console.log("Service worker has been registered.");
  },

  cached() {
    console.log("Content has been cached for offline use.");
  },

  updatefound() {
    console.log("New content is downloading.");
  },

  updated(registration) {
    console.log("🔁 New content is available; prompting user to refresh.");

    const doReload = window.confirm(
      "Uma nova versão está disponível. Deseja atualizar agora?"
    );

    if (doReload && registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  },

  offline() {
    console.log(
      "No internet connection found. App is running in offline mode."
    );
  },
  error(error) {
    console.error("Error during service worker registration:", error);
  },
});

// ✅ Recarregar apenas após o novo SW assumir o controle da aba
navigator?.serviceWorker?.addEventListener("controllerchange", () => {
  if (refreshing) return;
  refreshing = true;
  window.location.reload();
});

// ✅ Verificação periódica por nova versão
if (!window.__SW_UPDATE_CHECK_STARTED__) {
  window.__SW_UPDATE_CHECK_STARTED__ = true;

  setInterval(() => {
    navigator?.serviceWorker?.getRegistration().then((registration) => {
      if (registration) {
        registration.update();
      }
    });
  }, 1000 * 60 * 1); // a cada 1 minuto
}
